let walletDetails=null;
export function setWalletDetails(item)
{
    walletDetails = item;
}

export function getWalletDetails(){
    return walletDetails;
}